<template>
  <CModal
    size="lg"
    :centered="false"
    :closeOnBackdrop="false"
    :show.sync="isAddQueueShow"
    class="CmodalCustom"
  >
    <div class="bg-tranparent">
      <CCard class="bg-tranparent">
        <CCardBody>
          <template v-if="checkWidth >= 1202">
            <CRow alignVertical="center" alignHorizontal="center">
              <CCol
                :xl="{size: '3'}"
                :lg="{size: '3'}"
                :md="{size: '3'}"
                :sm="{size: '3'}"
                style="display: flex; justify-content: flex-end"
              >
                <img :src="avatarA" width="100%" />
              </CCol>
              <CCol
                :xl="{size: '6'}"
                :lg="{size: '6'}"
                :md="{size: '6'}"
                :sm="{size: '6'}"
              >
                <ChatPopup
                  :cardContent="chatDisplay"
                  :checkWidth="checkWidth"
                />
              </CCol>
              <CCol
                :xl="{size: '3'}"
                :lg="{size: '3'}"
                :md="{size: '3'}"
                :sm="{size: '3'}"
                style="display: flex; justify-content: flex-start"
              >
                <img :src="avatarB" width="100%" />
              </CCol>
            </CRow>
          </template>
          <template v-else-if="checkWidth <= 1201 && checkWidth >= 501">
            <CRow alignVertical="center" alignHorizontal="center">
              <CCol
                :xl="{size: '3'}"
                :lg="{size: '3'}"
                :md="{size: '3'}"
                :sm="{size: '3'}"
                xs="1"
                style="display: flex; justify-content: flex-start"
              >
                <img :src="avatarA" width="70%" height="20%" />
              </CCol>
              <CCol
                :xl="{size: '6'}"
                :lg="{size: '6'}"
                :md="{size: '6'}"
                :sm="{size: '6'}"
              >
                <ChatPopup
                  :cardContent="chatDisplay"
                  :checkWidth="checkWidth"
                />
              </CCol>
              <CCol
                :xl="{size: '3'}"
                :lg="{size: '3'}"
                :md="{size: '3'}"
                :sm="{size: '3'}"
                xs="1"
                style="display: flex; justify-content: flex-end"
              >
                <img :src="avatarB" width="70%" height="20%" />
              </CCol>
            </CRow>
          </template>
          <template v-else-if="checkWidth <= 500">
            <CRow>
              <CCol col="3" style="display: flex; justify-content: flex-start">
                <img class="AvatarA" :src="avatarA" width="200%" height="30%" />
              </CCol>
              <CCol col="6">
                <ChatPopup
                  :cardContent="chatDisplay"
                  :checkWidth="checkWidth"
                />
              </CCol>
              <CCol col="3" style="display: flex; justify-content: flex-end">
                <img class="AvatarA" :src="avatarB" width="200%" height="30%" />
              </CCol>
            </CRow>
          </template>
          <CRow alignVertical="center" alignHorizontal="center">
            <CButton
              color="danger"
              shape="pill"
              size="lg"
              class="ml-2 mr-2 mt-5 pl-5 pr-5 pt-3 pb-3"
              @click="close(cardContent)"
              >{{
                checkLanguage(cardContent?.navigate?.previous?.title)
              }}</CButton
            >
            <CButton
              color="success"
              shape="pill"
              size="lg"
              class="ml-2 mr-2 mt-5 pl-5 pr-5 pt-3 pb-3"
              @click="nextConver(cardContent)"
              >{{ checkLanguage(cardContent?.navigate?.next?.title) }}</CButton
            >
          </CRow>
        </CCardBody>
      </CCard>
    </div>
  </CModal>
</template>

<script>
import '../../../../assets/scss/_chineseStyle.scss';
import ChatPopup from '../../../../components/template/Chinese1/ChatPopup.vue';
import {mapGetters} from 'vuex';
export default {
  components: {ChatPopup},
  name: 'PopupConver',
  props: {
    isAddQueueShow: Boolean,
    setAddQueueVisible: Function,
    nextTo: Function,
    cardContent: Object,
    closeModal: Function,
    checkWidth: String,
    defaultChat: Boolean,
  },
  data() {
    return {
      chatDisplay: [],
      avatarA: '',
      avatarB: '',
      avatarMobileA: '',
      avatarMobileB: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      lang: '',
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
    }),
  },

  watch: {
    cardContent: function () {
      for (let Avatar of this.cardContent.content.image) {
        if (Avatar.position == 0 || Avatar.position === 'left') {
          this.avatarA = this.baseUrl + Avatar.url;
          let item = Avatar.url.split('_');
          this.avatarMobileA =
            this.baseUrl +
            item[0] +
            '_' +
            item[1] +
            '_' +
            'circle' +
            '_' +
            item[3];
        } else if (Avatar.position == 1 || Avatar.position === 'right') {
          this.avatarB = this.baseUrl + Avatar.url;
          let item = Avatar.url.split('_');
          this.avatarMobileB =
            this.baseUrl +
            item[0] +
            '_' +
            item[1] +
            '_' +
            'circle' +
            '_' +
            item[3];
        }
      }
      this.nextConver(this.cardContent);
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
  },

  mounted() {},

  created() {
    this.lang = this.$store.getters['language/getLanguage'];
  },

  beforeDestroy() {},
  methods: {
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
        console.log('change language is error!!');
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    close(val) {
      var pathNext = val.navigate.previous.action;

      this.nextTo(pathNext);
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    nextConver(val) {
      var pathNext = val.navigate.next.action;
      if (this.chatDisplay.length == 0) {
        this.chatDisplay.push(
          this.cardContent.content.image[this.chatDisplay.length]
        );
      } else if (
        this.chatDisplay.length < this.cardContent.content.image.length
      ) {
        this.chatDisplay.push(
          this.cardContent.content.image[this.chatDisplay.length]
        );
      } else {
        this.nextTo(pathNext);
      }
    },
  },
};
</script>

<style scoped>
.modal {
  backdrop-filter: blur(40px) !important;
}
.bg-tranparent {
  background-color: transparent;
  border: 0px;
}
.ConverUser {
  width: 4rem;
  height: 4rem;
  border-radius: none !important;
  border: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .AvatarA {
    width: 200px;
    height: 200px;
    position: absolute;
    left: -65px;
  }
}
</style>
